import { Injectable } from '@angular/core';


import { IJobDocumentTreeNodeViewModel, IDownloadJobDocumentRequest, IAddJobDocumentFolderRequest, IJobDocumentTreeViewModel } from '../shared/models/nola-job-document-models';

import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';

import { HttpClient, HttpResponse, HttpRequest } from '@angular/common/http';
import { $http } from '@caslink/common-client/ng-app/ajs-upgraded-providers';
import { Inject } from '@angular/core';
import { Observable } from 'rxjs';


import { map, take } from 'rxjs/operators';
import * as saveAs from 'file-saver';

import { HttpParams } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class NolaJobDocumentService {

    constructor(
        private proxyService: ProxyService,
        private http: HttpClient,
        @Inject($http) private angularHttp: angular.IHttpService
    ) {
    }


    public addJobDocumentFolderImp(request: IAddJobDocumentFolderRequest): angular.IPromise<IJobDocumentTreeNodeViewModel> {
        return this.proxyService.request({
            endPoint: 'jobDocument',
            route: 'addJobDocumentFolder',
            data: request
        }).as<IJobDocumentTreeNodeViewModel>();
    }

    public getJobDocumentTreeImp(hardwareItemId: number, search: string): angular.IPromise<IJobDocumentTreeViewModel> {
        return this.proxyService.request({
            endPoint: 'jobDocument',
            route: 'getJobDocumentTree',
            queryParams: {
                hardwareItemId: hardwareItemId,
                search: search
            }
        }).as<IJobDocumentTreeViewModel>();
    }

    public deleteJobDocument(hardwareItemId: number, documentId: number): angular.IPromise<boolean> {
        return this.proxyService.request({
            endPoint: 'jobDocument',
            route: 'deleteJobDocument',
            routeParams: {
                documentId: documentId
            },
            queryParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<boolean>();
    }

    public deleteJobDocuments(hardwareItemId: number, documentIds: number[]): Observable<any> {
        let params = new HttpParams();
        params = params.append('hardwareItemId', hardwareItemId.toString());
        for (var i = 0; i < documentIds.length; i++) {
            params = params.append('documentIds', documentIds[i].toString());
        }

        params.toString
        return this.http.delete('api/jobDocument/deleteJobDocuments?' + params.toString(), {
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-Token': this.angularHttp.defaults.headers.common['X-XSRF-Token']
            },
            withCredentials: true,
        });

    }

    public downloadDocumentImp(request: IDownloadJobDocumentRequest): Observable<void> {
        return this.http.post('api/jobDocument/downloadDocument', request,
            {
                headers: {
                    'X-XSRF-Token': this.angularHttp.defaults.headers.common['X-XSRF-Token']
                },
                observe: 'response',
                responseType: 'blob',
                withCredentials: true,
            }).pipe(map((res: HttpResponse<Blob>) => {
                const file = new Blob([res.body], { type: res.headers.get('file-content-type') || 'text/plain' });

                saveAs(file, res.headers.get('file-name'));
            })).pipe(take(1));
    }

    public uploadAddFile(file: File, selectedNodeData: IJobDocumentTreeNodeViewModel, hardwareItemId: number): Observable<Object> {

        return this.http.post('api/jobDocument/uploadDocument/' + hardwareItemId.toString(), file,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-Token': this.angularHttp.defaults.headers.common['X-XSRF-Token'],
                    'File-Name': file.name,
                    'File-Type': file.type,
                    'File-Size': file.size.toString(),
                    'File-LastModified': file.lastModified.toString(),
                    'Doc-ParentDocumentId': (selectedNodeData != null && selectedNodeData.documentId != null && selectedNodeData.documentId != 0) ? selectedNodeData.documentId.toString() : null

                },
                withCredentials: true,
            });
    }

    public uploadNewFile(file: File, hardwareItemId: number): Observable<Object> {

        return this.http.post('api/jobDocument/uploadDocument/' + hardwareItemId.toString(), file,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-Token': this.angularHttp.defaults.headers.common['X-XSRF-Token'],
                    'File-Name': file.name,
                    'File-Type': file.type,
                    'File-Size': file.size.toString(),
                    'File-LastModified': file.lastModified.toString(),
                    'Doc-ParentDocumentId': ""
                },
                withCredentials: true,
            });
    }

    public archiveJobDocument(hardwareItemId: number, documentId: number, folderName: string): angular.IPromise<void> {
        return this.proxyService.request({
            endPoint: 'jobDocument',
            route: 'archiveJobDocument',
            routeParams: {
                documentId: documentId,
                hardwareItemId: hardwareItemId
            },
            data: new String(folderName),
        }).as<void>();

    }

}